// import "./dotsAnimation.css";
import React from "react";
import { Box, keyframes, usePrefersReducedMotion } from "@chakra-ui/react";

export function Dots({ backgroundColor = "#fff" }) {
  const prefersReducedMotion = usePrefersReducedMotion();
  const animation1 = prefersReducedMotion
    ? undefined
    : `${keyframe_dot1} infinite 1s linear`;
  const animation2 = prefersReducedMotion
    ? undefined
    : `${keyframe_dot2} infinite 1s linear`;
  const animation3 = prefersReducedMotion
    ? undefined
    : `${keyframe_dot3} infinite 1s linear`;

  const dotStyles = {
    dot1: {
      position: "relative",
      width: "8px",
      height: "8px",
      borderRadius: "5px",
      backgroundColor: backgroundColor,
      color: backgroundColor,
      display: "inline-block",
      margin: "0 3px"
    },
    dot2: {
      width: "8px",
      height: "8px",
      borderRadius: "5px",
      backgroundColor: backgroundColor,
      color: backgroundColor,
      display: "inline-block",
      margin: "0 3px"
    },
    dot3: {
      width: "8px",
      height: "8px",
      borderRadius: "5px",
      backgroundColor: backgroundColor,
      display: "inline-block",
      margin: "0 3px"
    }
  };

  return (
    <Box>
      <Box style={dotStyles.dot1} animation={animation1} />
      <Box style={dotStyles.dot2} animation={animation2} />
      <Box style={dotStyles.dot3} animation={animation3} />
    </Box>
  );
}

const keyframe_dot1 = keyframes`
  0% { transform: scale(1, 1); }
  25% { transform: scale(1, 1.5); }
  50% { transform: scale(1, 0.67); }
  75% { transform: scale(1, 1); }
  100% { transform: scale(1, 1); }
`;

const keyframe_dot2 = keyframes`
  0% { transform: scale(1, 1); }
  25% { transform: scale(1, 1); }
  50% { transform: scale(1, 1.5); }
  75% { transform: scale(1, 1); }
  100% { transform: scale(1, 1); }
`;

const keyframe_dot3 = keyframes`
  0% { transform: scale(1, 1); }
  25% { transform: scale(1, 1); }
  50% { transform: scale(1, 0.67); }
  75% { transform: scale(1, 1.5); }
  100% { transform: scale(1, 1); }
`;
